import React, { useState } from 'react';
import {
  Button, Grid, TextField, Select, MenuItem, FormControl, InputLabel, Box, Typography, Checkbox, Paper, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow
} from '@mui/material';

const TicketStatusUpdate = () => {
  const [formData, setFormData] = useState({
    fromDate: '',
    toDate: '',
    category: '',
    subcategory: '',
    status: '',
    remarks: ''
  });
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const categories = ['Category 1', 'Category 2', 'Category 3'];
  const subcategories = ['Subcategory 1', 'Subcategory 2', 'Subcategory 3'];
  const statuses = ['Pending', 'In Progress', 'Resolved'];

  const rows = [
    { id: 1, date: '2025-01-01', name: 'John Doe', mobile: '1234567890', status: 'Pending' },
    // Add more rows here...
  ];

  const columns = [
    { id: 'date', label: 'Date' },
    { id: 'name', label: 'Name' },
    { id: 'mobile', label: 'Mobile' },
    { id: 'status', label: 'Status' }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);
    setSelectedRows(checked ? rows.map((row) => row.id) : []);
  };

  const handleRowSelect = (rowId) => {
    setSelectedRows((prev) =>
      prev.includes(rowId) ? prev.filter((id) => id !== rowId) : [...prev, rowId]
    );
  };

  const handleCancel = () => {
    // Clear form or handle cancel action
    setFormData({
      fromDate: '',
      toDate: '',
      category: '',
      subcategory: '',
      status: '',
      remarks: ''
    });
  };

  const handleUpdate = () => {
    // Implement the update logic
    console.log('Updating...');
  };

  return (
    <Grid container spacing={3}>
      {/* Filter Section */}
      <Grid item xs={12}>
        <Box display="flex" justifyContent="space-between" alignItems="center" gap={2}>
          <TextField
            fullWidth
            label="From Date"
            type="date"
            name="fromDate"
            value={formData.fromDate}
            onChange={handleInputChange}
            variant="filled"
            InputLabelProps={{
              shrink: true,
            }}
            sx={{ maxWidth: '30%' }}
          />
          <TextField
            fullWidth
            label="To Date"
            type="date"
            name="toDate"
            value={formData.toDate}
            onChange={handleInputChange}
            variant="filled"
            InputLabelProps={{
              shrink: true,
            }}
            sx={{ maxWidth: '30%' }}
          />
        </Box>
      </Grid>

      {/* Category, Subcategory, Status and Remarks */}
      <Grid item xs={12}>
        <Box display="flex" gap={2}>
          <FormControl fullWidth variant="filled" sx={{ maxWidth: '20%' }}>
            <InputLabel>Category</InputLabel>
            <Select
              name="category"
              value={formData.category}
              onChange={handleInputChange}
              className="custom-textfield"
            >
              {categories.map((category, idx) => (
                <MenuItem key={idx} value={category}>
                  {category}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth variant="filled" sx={{ maxWidth: '20%' }}>
            <InputLabel>Subcategory</InputLabel>
            <Select
              name="subcategory"
              value={formData.subcategory}
              onChange={handleInputChange}
              className="custom-textfield"
            >
              {subcategories.map((subcategory, idx) => (
                <MenuItem key={idx} value={subcategory}>
                  {subcategory}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth variant="filled" sx={{ maxWidth: '20%' }}>
            <InputLabel>Status</InputLabel>
            <Select
              name="status"
              value={formData.status}
              onChange={handleInputChange}
              className="custom-textfield"
            >
              {statuses.map((status, idx) => (
                <MenuItem key={idx} value={status}>
                  {status}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            fullWidth
            label="Remarks"
            name="remarks"
            value={formData.remarks}
            onChange={handleInputChange}
            variant="filled"
            className="custom-textfield"
            sx={{ maxWidth: '20%' }}
          />
        </Box>
      </Grid>

      {/* Cancel & Update Buttons */}
      <Grid item xs={12} display="flex" justifyContent="flex-end" gap={2}>
        <Button variant="contained" color="error" onClick={handleCancel}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={handleUpdate}>
          Update
        </Button>
      </Grid>

      {/* Table Section */}
      <Grid item xs={12}>
        <Paper sx={{ marginTop: 2 }}>
          <TableContainer sx={{ maxHeight: 360 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow
                  sx={{
                    '& > th': {
                      padding: '2px 10px 2px 10px',
                    },
                  }}
                >
                  <TableCell padding="checkbox" style={{ width: 80, textAlign: 'center' }}>
                    <Typography variant="subtitle1" fontWeight="bold">
                      All
                    </Typography>
                    <Checkbox checked={selectAll} onChange={handleSelectAll} />
                  </TableCell>
                  {columns.map((column) => (
                    <TableCell key={column.id} align="left" style={{ minWidth: column.minWidth }}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        {column.label}
                      </Typography>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.length > 0 ? (
                  rows.map((row) => (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={row.id}
                      sx={{
                        '& > td': {
                          padding: '2px 14px 2px 19px',
                        },
                      }}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedRows.includes(row.id)}
                          onChange={() => handleRowSelect(row.id)}
                        />
                      </TableCell>
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell key={column.id} align="left">
                            {value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns.length + 1}>No records found</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default TicketStatusUpdate;
